import React from 'react'
import gql from 'graphql-tag'
import { Mutation } from 'react-apollo'
import { PureQueryOptions } from 'apollo-client'
import { FormattedMessage } from 'react-intl'
import { ConfirmationDialog } from '../../legacy-design-system/modal'
import { Checkbox } from '../../legacy-design-system/checkbox'
import { Severity } from '../vulnerability-severity'
import { VulnerabilitySeverityName } from '../vulnerability-severity/severity'

interface Response {
  readonly updateVulnerabilitySeverity: {
    readonly id: string
    readonly severity: VulnerabilitySeverityName
    readonly __typename: string
  }
  readonly __typename: string
}

interface Vars {
  readonly input: {
    readonly organizationID: string
    readonly vulnerabilityID: string
    readonly severity: VulnerabilitySeverityName
    readonly overrideAll: boolean
  }
}

export interface Props {
  readonly isOpen: boolean
  readonly onClose: () => void
  readonly refetchQueries: PureQueryOptions[]
  readonly refresh: () => Promise<any>
  readonly organizationID: string
  readonly vulnerabilityID: string
  readonly severity: Severity
}

interface State {
  readonly overrideAll: boolean
}

export class VulnerabilitySeverityChangeModal extends React.Component<
  Props,
  State
> {
  public state: State = {
    overrideAll: false
  }

  public render() {
    const {
      organizationID,
      vulnerabilityID,
      severity,
      isOpen,
      onClose,
      refetchQueries,
      refresh
    } = this.props
    const { overrideAll } = this.state
    return (
      <Mutation<Response, Vars>
        mutation={gql`
          mutation UpdateVulnerbilitySeverity(
            $input: VulnerabilityUpdateSeverityMutationArgs!
          ) {
            updateVulnerabilitySeverity(input: $input) {
              id
              severity
            }
          }
        `}
        variables={{
          input: {
            organizationID,
            vulnerabilityID,
            severity: severity.name,
            overrideAll
          }
        }}
      >
        {(changeSeverity) => {
          return (
            <FormattedMessage id="title_vulnerabilityTrace_overrideSeverityConfirmation">
              {(title) => {
                return (
                  <ConfirmationDialog
                    size="medium"
                    isOpen={isOpen}
                    onCancel={onClose}
                    onConfirm={() => {
                      // eslint-disable-next-line @typescript-eslint/no-floating-promises
                      changeSeverity({
                        refetchQueries,
                        optimisticResponse: {
                          updateVulnerabilitySeverity: {
                            id: vulnerabilityID,
                            severity: severity.name,
                            __typename: 'Vulnerability'
                          },
                          __typename: 'Mutation'
                        }
                      }).then(refresh)
                      onClose()
                    }}
                    renderTitle={() => title}
                    renderConfirmMessage={() => (
                      <FormattedMessage id="action_override" />
                    )}
                    renderCancelMessage={() => (
                      <FormattedMessage id="action_cancel" />
                    )}
                    renderBody={() => {
                      return (
                        <React.Fragment>
                          <FormattedMessage id="detail_vulnerabilityTrace_overrideSeverityConfirmation">
                            {(text) => {
                              return <p>{text}</p>
                            }}
                          </FormattedMessage>
                          <FormattedMessage id="detail_vulnerabilityTrace_overrideSeverityConfirmationApplyToAll">
                            {(label) => {
                              return (
                                <Checkbox
                                  label={label as any}
                                  value={overrideAll}
                                  onChange={this.onOverrideChange}
                                />
                              )
                            }}
                          </FormattedMessage>
                        </React.Fragment>
                      )
                    }}
                  />
                )
              }}
            </FormattedMessage>
          )
        }}
      </Mutation>
    )
  }

  public onOverrideChange = (overrideAll: boolean) => {
    this.setState({
      overrideAll
    })
  }
}
